const re = /^([^\s]+:\/\/)*([^/?]+)(.*)$/i;

export default function normalizeWebsiteUrl(value, proto = 'https://') {
    const match = value && value.trim().match(re);

    if (match) {
        const protocol = match[1] || proto;
        const host = match[2];
        const rest = match[3];

        return protocol.toLowerCase() + host.toLowerCase() + rest;
    }

    return value;
}
